<ng-container *ngIf="showSearch">
  <ion-searchbar
    [(ngModel)]="searchTerm"
    (ionInput)="onSearchChange($event)">
  </ion-searchbar>
</ng-container>

<div class="contact-list">
  <div class="contact-row"
       *ngFor="let item of dataListFiltered; trackBy: trackByContactId"
       (click)="convertContact(item)">
    <div class="contact-info">
      <span class="contact-name">{{ item.companyName || item.company || item.displayName }}</span>
      <span class="contact-meta" *ngIf="item.address?.street">{{ item.address.street }}</span>
      <span class="contact-meta" *ngIf="item.address?.zip || item.address?.city">{{ item.address?.zip }} {{ item.address?.city }}</span>
    </div>
    <ion-icon name="chevron-forward-outline" class="contact-chevron"></ion-icon>
  </div>

  <div class="contact-empty" *ngIf="dataListFiltered?.length === 0">
    <ion-icon name="people-outline"></ion-icon>
    <span>Keine Ergebnisse</span>
  </div>
</div>
